import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { logoutUser } from "../../store/actions";

//redux
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearStoredSelectedDoctorId } from "helpers/doctorSelection";

const Logout = () => {
  const history = useNavigate();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  clearStoredSelectedDoctorId();
  localStorage.removeItem("InfuseoneUserToken");
  localStorage.removeItem("Infuseonerolename");
  localStorage.removeItem("Infuseoneuserinfo");
  navigate("/");

  useEffect(() => {
    dispatch(logoutUser(history));
  }, [dispatch, history]);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
